__webpack_public_path__ = window.CDN_DOMAIN


// WEBPACK FOOTER //
// ./public/hws/publicPath.js